import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';

import Icon from '../../common/icon';
import NavTooltip from './NavTooltip';

class NavLink extends Component {
  state = { hover: false }

  onMouseOver = () => this.setState({ hover: true });

  onMouseOut = () => this.setState({ hover: false });

  render() {
    const { id, text, iconName, url, collapsed, onClick, className, href, linkAttrs } = this.props;

    if (href) {
      return (
        <a
          className="c-user-nav__link"
          data-automation-id={`nav-item-${id}`}
          onClick={onClick}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          href={href}
          {...(linkAttrs || {})}
        >
          <span className="c-info-tooltip-handler">
            <Icon glyph={iconName} size="small" />
            <div className="c-nav-tooltip">
              <NavTooltip active={this.state.hover}>{text}</NavTooltip>
            </div>
            <span className="c-user-nav__text" display-if={!collapsed}>{text}</span>
          </span>
        </a>
      );
    }

    return (
      <Link
        to={url}
        className={classnames('c-user-nav__link', className)}
        activeClassName="c-user-nav__link is-active"
        data-automation-id={`nav-item-${id}`}
        onClick={onClick}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
      >
        <span className="c-info-tooltip-handler">
          <Icon glyph={iconName} size="small" />
          <div className="c-nav-tooltip">
            <NavTooltip active={this.state.hover}>{text}</NavTooltip>
          </div>
          <span className="c-user-nav__text" display-if={!collapsed}>{text}</span>
        </span>
      </Link>
    );
  }
}

NavLink.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  iconName: PropTypes.shape({ id: PropTypes.string }),
  url: PropTypes.string,
  href: PropTypes.string,
  linkAttrs: PropTypes.object, // attributes that will be passed directly to the link, like target="_blank"
  collapsed: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

NavLink.defaultProps = {
  id: '',
  text: '',
  iconName: '',
  url: '',
  href: '',
  collapsed: false,
  onClick: () => null,
  className: '',
  linkAttrs: {},
};

export default NavLink;
